import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SystemService {
  private readonly maintenanceKey = 'maintenanceMode';
  private readonly expirationKey = 'maintenanceExpiration';
  private readonly cacheDuration = 60 * 1000;
  private apiUrl = `${environment.apiUrl}/system/status`;

  constructor(private http: HttpClient) {}

  getMaintenanceStatus(): Observable<boolean> {
    const cachedValue = localStorage.getItem(this.maintenanceKey);
    const cachedExpiration = localStorage.getItem(this.expirationKey);
    const now = Date.now();

    if (cachedValue !== null && cachedExpiration !== null && now < +cachedExpiration) {
      return of(cachedValue === 'true');
    }

    return this.http.get<{ maintenance: boolean }>(this.apiUrl).pipe(
      tap((response) => {
        localStorage.setItem(this.maintenanceKey, String(response.maintenance));
        localStorage.setItem(this.expirationKey, String(now + this.cacheDuration));
      }),
      map(response => response.maintenance)
    );
  }
}
